import { HeartStroke16 } from '@cian/ui-kit/icons';
import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackFavoritesIconClick } from './tracking';
import { Utility } from '../../components/Utility';
import { IApplicationState } from '../../types/redux';

export const UtilityFavoritesContainer: React.FC = () => {
  const [isMainPage, setIsMainPage] = React.useState(false);

  const deviceType = useDeviceType();
  const favoritesLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.favorites);

  const handleClick = React.useCallback(() => {
    trackFavoritesIconClick();
  }, [deviceType]);

  React.useEffect(() => {
    // Открываем вкладку Избранного в той же, если переход с главной страницы
    setIsMainPage(window.location.pathname === '/');
  }, []);

  if (!favoritesLink) {
    return null;
  }

  return (
    <div data-testid="utility-title">
      <Utility
        title="Избранное"
        icon={HeartStroke16}
        href={favoritesLink}
        onClick={handleClick}
        target={isMainPage ? '_self' : '_blank'}
      />
    </div>
  );
};
